import styled from 'styled-components';
import { Button } from 'kl-b2c-ui-kit';
import { mediaMd, mediaSm } from 'theme/theme-helper-selectors';
import { Link } from 'react-router-dom';

export const PrimaryButton = styled(Button)<{ paddingTop?: number; paddingLeft?: number }>`
    text-transform: unset;
    letter-spacing: 0;
    background-image: ${({ theme }) => theme.palette.green};
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.secondary};
    border-radius: 40px;
    font-size: 21px;
    line-height: 24px;
    padding: ${({ paddingTop = 23 }) => paddingTop}px ${({ paddingLeft = 53 }) => paddingLeft}px;

    height: 74px;

    @media (${mediaMd}) {
        height: 60px;
        font-size: 18px;
        line-height: 18px;
    }

    @media (${mediaSm}) {
        height: 48px;
        font-size: 16px;
        line-height: 16px;
    }
`;

export const PrimaryLink = styled(Link)<{ paddingTop?: number; paddingLeft?: number }>`
    text-transform: unset;
    letter-spacing: 0;
    background: ${({ theme }) => theme.palette.green};

    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.secondary};
    border-radius: 40px;
    font-size: 21px;
    line-height: 24px;
    padding: ${({ paddingTop = 23 }) => paddingTop}px ${({ paddingLeft = 53 }) => paddingLeft}px;
    text-align: center;

    height: 74px;
    transition: all 150ms ease-in-out;

    &:hover {
        color: ${({ theme }) => theme.palette.text.secondary};
        opacity: 0.8;
    }

    @media (${mediaMd}) {
        height: 60px;
        font-size: 18px;
        line-height: 18px;
    }

    @media (${mediaSm}) {
        height: 48px;
        font-size: 16px;
        line-height: 16px;
    }
`;

export const SecondaryButton = styled(Button).attrs({
    variant: 'outlined',
})`
    padding: 12px 21px;
    font-weight: 400;
    text-transform: none;
    line-height: 1.25;
    color: #fff;
    border: 2px solid #fff;
    letter-spacing: initial;
`;
